// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Sj-z","itemsContainer":"Tj-z"};